import routes from 'global/Constants/routes';

import { lazy } from 'react';

const SSOLoginWithOTPCode = lazy(() => import('../../pages/loginWithOTP/LoginWithOTPCode'));
const SSOLoginPage = lazy(() => import('../../pages/login/SSOLoginPage'));
const HomePage = lazy(() => import('../../pages/home/HomePage'));
const RegisterSSOPage = lazy(() => import('../../pages/register/RegisterSSOPage'));
const AboutUs = lazy(() => import('../../pages/home/aboutUs/AboutUs'));
const ContactUs = lazy(() => import('../../pages/home/contactUs/ContactUs'));
const Branches = lazy(() => import('../../pages/home/branches/BranchesPage'));
const RegisterVerification = lazy(() => import('../../pages/home/registerVerification/RegisterVerification'));
const ParcelBarcodePrint = lazy(() => import('../../pages/dashboard/parcelBarcodePrint/ParcelBarcodePrint'));
const ParcelBarcodesPrintList = lazy(() => import('../../pages/dashboard/ParcelOrder/List/components/OrdersBarcodesPrintList'));
const ParcelDetailPrint = lazy(() => import('../../pages/dashboard/parcelDetailPrint/ParcelDetailPrint'));
const OrderDetailPrint = lazy(() => import('../../pages/dashboard/OrderDetailPrint/OrderDetailPrint'));
const AppDownload = lazy(() => import('../../pages/appDownload/AppDownload'));
const ProductTerms = lazy(() => import('../../pages/home/productTerms/ProductTerms'));

export const homeRoutes = (hasAccessLevel: (_level: number) => boolean) => [
  {
    path: routes.appdl.path,
    component: AppDownload,
    isPrivate: false,
    accessRole: true,
  },
  {
    path: routes.parcelBarcodesPrintList.path,
    component: ParcelBarcodesPrintList,
    isPrivate: routes.parcelBarcodesPrintList.isPrivate,
    accessRole: hasAccessLevel(10),
  },
  {
    path: routes.orderDetailPrint.path,
    component: OrderDetailPrint,
    isPrivate: routes.orderDetailPrint.isPrivate,
    accessRole: hasAccessLevel(10),
  },
  {
    path: routes.parcelDetailPrint.path,
    component: ParcelDetailPrint,
    isPrivate: routes.parcelDetailPrint.isPrivate,
    accessRole: hasAccessLevel(10),
  },
  {
    path: routes.parcelBarcodePrint.path,
    component: ParcelBarcodePrint,
    isPrivate: routes.parcelBarcodePrint.isPrivate,
    accessRole: hasAccessLevel(10),
  },
  {
    path: routes.branches.path,
    component: Branches,
    isPrivate: routes.branches.isPrivate,
    accessRole: hasAccessLevel(10),
  },
  {
    path: routes.aboutUs.path,
    component: AboutUs,
    isPrivate: routes.aboutUs.isPrivate,
    accessRole: hasAccessLevel(10),
  },
  {
    path: routes.contactUs.path,
    component: ContactUs,
    isPrivate: routes.contactUs.isPrivate,
    accessRole: hasAccessLevel(10),
  },
  {
    path: routes.productTerm.path,
    component: ProductTerms,
    isPrivate: routes.productTerm.isPrivate,
    accessRole: hasAccessLevel(10),
  },
  {
    path: routes.registerVerification.path,
    component: RegisterVerification,
    isPrivate: routes.registerVerification.isPrivate,
    accessRole: hasAccessLevel(10),
  },
  {
    path: routes.register.path,
    component: RegisterSSOPage,
    isPrivate: routes.register.isPrivate,
    accessRole: hasAccessLevel(10),
  },
  { path: routes.loginWithOtpCode.path, component: SSOLoginWithOTPCode, isPrivate: routes.loginWithOtpCode.isPrivate, accessRole: hasAccessLevel(10) },
  {
    path: routes.login.path,
    component: SSOLoginPage,
    isPrivate: routes.login.isPrivate,
    accessRole: hasAccessLevel(10),
  },
  {
    path: routes.home.path,
    component: HomePage,
    isPrivate: routes.home.isPrivate,
    accessRole: hasAccessLevel(10),
  },
];
